<template>
    <div>
        <van-tabs v-model="activeIndex">
            <van-tab title="全部">
                <order-list :p_action="action" :p_status="0" />
            </van-tab>
            <van-tab title="待入账">
                <order-list :p_action="action" :p_status="1" />
            </van-tab>
            <van-tab title="可提现">
                <order-list :p_action="action" :p_status="2" />
            </van-tab>
            <van-tab title="退款售后">
                <order-list :p_action="action" :p_status="3" />
            </van-tab>
        </van-tabs>
        <partner-footer p_active="1" />
    </div>
</template>

<script>
    /*
     * 我的订单 - 代理人
     */
    import OrderList from "../../components/Order/OrderList";
    import PartnerFooter from "../../components/Footer/PartnerFooter";
    import store from '@/store';

    export default {
        name: "MyOrderAgent",
        components: {PartnerFooter, OrderList},
        data(){
            return{
                activeIndex:this.$route.params.status?this.$route.params.status:0,
                action:'2', //耘径联盟（2）
            }
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            if(loginUser&&loginUser.openid){
                next();
            }else{
                next({path:'/join'});
            }
        },
    }
</script>

<style scoped>

</style>
